var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getLanguageFromStorage } from 'syf-js-utilities';
import i18n, { translate } from '../strings/i18n';
var getTranslation = function (lang) {
    if (lang === void 0) { lang = getLanguageFromStorage(); }
    i18n.changeLanguage(lang);
    var labelsFromTranslate = {
        firstNamePlaceholder: translate('addAuthUserScreen.firstNameInputPlaceholder'),
        firstNameHelpText: translate('addAuthUserScreen.firstNameInputHelpText'),
        firstNameError: translate('addAuthUserScreen.firstNameInputError'),
        lastNamePlaceholder: translate('addAuthUserScreen.lastNameInputPlaceholder'),
        lastNameHelpText: translate('addAuthUserScreen.lastNameInputHelpText'),
        lastNameError: translate('addAuthUserScreen.lastNameInputError'),
        birthDatePlaceholder: translate('addAuthUserScreen.birthDateInputPlaceholder'),
        birthDateHelpText: translate('addAuthUserScreen.birthDateInputHelpText'),
        birthDateInvalidError: translate('addAuthUserScreen.birthDateInputInvalidDateError'),
        birthDateFutureError: translate('addAuthUserScreen.birthDateInputFutureError'),
        birthDatePastError: translate('addAuthUserScreen.birthDateInputPastYearError')
    };
    return __assign(__assign({}, labelsFromTranslate), { inputTypeHelpText: {
            authorizedUserFirstName: labelsFromTranslate.firstNameHelpText,
            authorizedUserLastName: labelsFromTranslate.lastNameHelpText,
            authorizedUserBirthDate: labelsFromTranslate.birthDateHelpText
        }, inputErrorTypeText: {
            authorizedUserFirstName: labelsFromTranslate.firstNameError,
            authorizedUserLastName: labelsFromTranslate.lastNameError,
            authorizedUserBirthDate: labelsFromTranslate.birthDateHelpText,
            authorizedUserInvalidBirthDate: labelsFromTranslate.birthDateInvalidError,
            authorizedUserFutureBirthYear: labelsFromTranslate.birthDateFutureError,
            authorizedUserPastBirthYear: labelsFromTranslate.birthDatePastError
        } });
};
export default getTranslation;
